import { normalizeGender } from '../utils/genderUtils.js';
import { splitPromptTagsAware } from './bodyOptionCatalog.js';

const GENDER_TAG_KEYS = new Set(['1boy', '1girl']);

const normalizeTagKey = (tag) => String(tag || '').toLowerCase().replace(/\s+/g, ' ').trim();

const characterGenderTag = (gender) => (normalizeGender(gender) === 'male' ? '1boy' : '1girl');

const hasStandaloneTag = (prompt, tag) =>
    splitPromptTagsAware(prompt).some((token) => normalizeTagKey(token) === tag);

/** Prepend 1boy/1girl from the gender select when that exact tag is absent. */
export const withCharacterGenderTag = (prompt, gender) => {
    const tag = characterGenderTag(gender);
    const text = String(prompt || '').trim();
    if (hasStandaloneTag(text, tag)) return text;
    if (!text) return `${tag},`;
    return `${tag}, ${text}`;
};

/** Remove standalone 1boy/1girl only. Other count tags such as 2girls stay. */
export const stripCharacterGenderTags = (prompt) => {
    const text = String(prompt ?? '');
    const tokens = splitPromptTagsAware(text);
    if (!tokens.some((token) => GENDER_TAG_KEYS.has(normalizeTagKey(token)))) return text;

    const kept = tokens.filter((token) => !GENDER_TAG_KEYS.has(normalizeTagKey(token)));
    if (!kept.length) return '';

    const joined = kept.join(', ');
    return text.trim().endsWith(',') ? `${joined},` : joined;
};
